<div class="flex justify-center items-center h-screen p-4">
  <div class="x-card x-card_size_m x-white w-full max-w-2xl">
    <h1 class="x-card__title">
      {{ 'core.person_required.title' | translate }}
    </h1>
    <p class="x-card__paragraph">
      {{ 'core.person_required.message' | translate }}
    </p>
    <button appearance="primary" tuiButton type="button" (click)="logout()">
      {{ 'core.person_required.logout' | translate }}
    </button>
  </div>
</div>
